import { UPDATES_NODE_TYPES } from '@/common/constants/updates.constants';

export default (service) => {
  const {
    name,
    installed_storage_release: currentRelease,
    available_storage_release: availableRelease,
    status, // UPDATES_SERVICE_STATUSES
  } = service;

  return ({
    name,
    id: name,
    currentRelease,
    availableRelease,
    status,
    type: UPDATES_NODE_TYPES.SERVICE
  });
};
